import React from 'react';
import { Route } from 'react-router';

import { all_routes } from './all-routes';
const Prices = React.lazy(() => import('../prices/presentation/pages/prices'));
const PriceForm = React.lazy(() => import('../prices/presentation/pages/price-form'));
const ServiceDetail = React.lazy(() => import('../pages/service-detail'));
const ServiceForm = React.lazy(() => import('../services/presentation/pages/service-form'));
const InstructorForm = React.lazy(
  () => import('../instructors/presentation/pages/instructor-form')
);
const InstructorDetail = React.lazy(() => import('../pages/instructor-detail'));
const FeatureForm = React.lazy(() => import('../features/presentation/pages/feature-form'));
const FeatureDetail = React.lazy(() => import('../pages/feature-detail'));
const EventDetail = React.lazy(() => import('../pages/event-detail'));
const Home = React.lazy(() => import('../pages/home'));
const AboutUs = React.lazy(() => import('../pages/about-us'));
const ContactUs = React.lazy(() => import('../contacts/presentation/pages/contact-us'));
const Error404 = React.lazy(() => import('../pages/error-404'));
const Events = React.lazy(() => import('../pages/events'));
const Services = React.lazy(() => import('../pages/services'));
const Instructors = React.lazy(() => import('../pages/instructors'));
const Features = React.lazy(() => import('../pages/features'));
const TermsCondition = React.lazy(() => import('../pages/terms-condition'));
const PrivacyPolicy = React.lazy(() => import('../pages/privacy-policy'));
const Pricing = React.lazy(() => import('../pages/pricing'));
const PricingDetail = React.lazy(() => import('../pages/pricing-detail'));
const OurTeams = React.lazy(() => import('../pages/our-teams'));
const Testimonials = React.lazy(() => import('../pages/testimonials'));
const Gallery = React.lazy(() => import('../pages/gallery'));
const Login = React.lazy(() => import('../auth/presentation/pages/login'));
const Users = React.lazy(() => import('../users/presentation/pages/users'));
const Dashboard = React.lazy(() => import('../dashboard/presentation/pages/dashboard'));
const UserForm = React.lazy(() => import('../users/presentation/pages/user-form'));
const UserDetails = React.lazy(() => import('../users/presentation/pages/user-details'));
const ProductCategories = React.lazy(
  () => import('../product-categories/presentation/pages/product-categories')
);
const ProductCategoryForm = React.lazy(
  () => import('../product-categories/presentation/pages/product-category-form')
);
const Products = React.lazy(() => import('../products/presentation/pages/products'));
const ProductForm = React.lazy(() => import('../products/presentation/pages/product-form'));
const ProductDetails = React.lazy(() => import('../products/presentation/pages/product-details'));
const Sales = React.lazy(() => import('../sales/presentation/pages/sales'));
const SaleForm = React.lazy(() => import('../sales/presentation/pages/sale-form'));
const SaleDetails = React.lazy(() => import('../sales/presentation/pages/sale-details'));
const Contacts = React.lazy(() => import('../contacts/presentation/pages/contacts'));
const FeeForm = React.lazy(() => import('../fees/presentation/pages/fee-form'));
const Fees = React.lazy(() => import('../fees/presentation/pages/fees'));
const FeeDetails = React.lazy(() => import('../fees/presentation/pages/fee-details'));
const DashboardServices = React.lazy(() => import('../services/presentation/pages/services'));
const DashboardInstructors = React.lazy(
  () => import('../instructors/presentation/pages/instructors')
);
const DashboardFeatures = React.lazy(() => import('../features/presentation/pages/features'));
const DashboardTestimonials = React.lazy(
  () => import('../testimonials/presentation/pages/testimonials')
);
const TestimonialForm = React.lazy(
  () => import('../testimonials/presentation/pages/testimonial-form')
);

const DashboardEvents = React.lazy(() => import('../events/presentation/pages/events'));
const EventForm = React.lazy(() => import('../events/presentation/pages/event-form'));

const DashboardGallery = React.lazy(() => import('../gallery/presentation/pages/gallery'));
const GalleryForm = React.lazy(() => import('../gallery/presentation/pages/gallery-form'));

const routes = all_routes;

const publicRoutes = [
  {
    path: routes.home,
    element: <Home />,
    route: Route,
  },
  {
    path: routes.aboutUs,
    element: <AboutUs />,
    route: Route,
  },
  {
    path: routes.contactUs,
    element: <ContactUs />,
    route: Route,
  },
  {
    path: routes.events,
    element: <Events />,
    route: Route,
  },
  {
    path: routes.services,
    element: <Services />,
    route: Route,
  },
  {
    path: routes.instructors,
    element: <Instructors />,
    route: Route,
  },
  {
    path: routes.features,
    element: <Features />,
    route: Route,
  },
  {
    path: routes.serviceDetail,
    element: <ServiceDetail />,
    route: Route,
  },
  {
    path: routes.instructorDetail,
    element: <InstructorDetail />,
    route: Route,
  },
  {
    path: routes.featureDetail,
    element: <FeatureDetail />,
    route: Route,
  },
  {
    path: routes.termsCondition,
    element: <TermsCondition />,
    route: Route,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
    route: Route,
  },
  {
    path: routes.pricing,
    element: <Pricing />,
    route: Route,
  },
  {
    path: routes.pricingDetail,
    element: <PricingDetail />,
    route: Route,
  },
  {
    path: routes.ourTeams,
    element: <OurTeams />,
    route: Route,
  },
  {
    path: routes.testimonials,
    element: <Testimonials />,
    route: Route,
  },
  {
    path: routes.gallery,
    element: <Gallery />,
    route: Route,
  },
  {
    path: routes.eventDetails,
    element: <EventDetail />,
    route: Route,
  },
  {
    path: '*',
    name: 'NotFound',
    element: <Error404 />,
    route: Route,
  },
];

const dashboardRoutes = [
  {
    path: routes.dashboard,
    element: <Dashboard />,
    route: Route,
  },
  {
    path: routes.users,
    element: <Users />,
    route: Route,
  },
  {
    path: routes.addUser,
    element: <UserForm />,
    route: Route,
  },
  {
    path: routes.showUser,
    element: <UserDetails />,
    route: Route,
  },
  {
    path: routes.editUser,
    element: <UserForm />,
    route: Route,
  },
  {
    path: routes.productCategories,
    element: <ProductCategories />,
    route: Route,
  },
  {
    path: routes.addProductCategory,
    element: <ProductCategoryForm />,
    route: Route,
  },
  {
    path: routes.editProductCategory,
    element: <ProductCategoryForm />,
    route: Route,
  },
  {
    path: routes.products,
    element: <Products />,
    route: Route,
  },
  {
    path: routes.addProduct,
    element: <ProductForm />,
    route: Route,
  },
  {
    path: routes.showProduct,
    element: <ProductDetails />,
    route: Route,
  },
  {
    path: routes.editProduct,
    element: <ProductForm />,
    route: Route,
  },
  {
    path: routes.sales,
    element: <Sales />,
    route: Route,
  },
  {
    path: routes.addSale,
    element: <SaleForm />,
    route: Route,
  },
  {
    path: routes.showSale,
    element: <SaleDetails />,
    route: Route,
  },
  {
    path: routes.editSale,
    element: <SaleForm />,
    route: Route,
  },
  {
    path: routes.fees,
    element: <Fees />,
    route: Route,
  },
  {
    path: routes.addFee,
    element: <FeeForm />,
    route: Route,
  },
  {
    path: routes.showFee,
    element: <FeeDetails />,
    route: Route,
  },
  {
    path: routes.editFee,
    element: <FeeForm />,
    route: Route,
  },
  {
    path: routes.contacts,
    element: <Contacts />,
    route: Route,
  },
  {
    path: routes.dashboardServices,
    element: <DashboardServices />,
    route: Route,
  },
  {
    path: routes.addService,
    element: <ServiceForm />,
    route: Route,
  },
  {
    path: routes.editService,
    element: <ServiceForm />,
    route: Route,
  },
  {
    path: routes.dashboardInstructors,
    element: <DashboardInstructors />,
    route: Route,
  },
  {
    path: routes.addInstructor,
    element: <InstructorForm />,
    route: Route,
  },
  {
    path: routes.editInstructor,
    element: <InstructorForm />,
    route: Route,
  },
  {
    path: routes.dashboardFeatures,
    element: <DashboardFeatures />,
    route: Route,
  },
  {
    path: routes.addFeature,
    element: <FeatureForm />,
    route: Route,
  },
  {
    path: routes.editFeature,
    element: <FeatureForm />,
    route: Route,
  },
  {
    path: routes.dashboardTestimonials,
    element: <DashboardTestimonials />,
    route: Route,
  },
  {
    path: routes.addTestimonial,
    element: <TestimonialForm />,
    route: Route,
  },
  {
    path: routes.editTestimonial,
    element: <TestimonialForm />,
    route: Route,
  },
  {
    path: routes.prices,
    element: <Prices />,
    route: Route,
  },
  {
    path: routes.addPrice,
    element: <PriceForm />,
    route: Route,
  },
  {
    path: routes.editPrice,
    element: <PriceForm />,
    route: Route,
  },
  {
    path: routes.dashboardEvents,
    element: <DashboardEvents />,
    route: Route,
  },
  {
    path: routes.addEvent,
    element: <EventForm />,
    route: Route,
  },
  {
    path: routes.editEvent,
    element: <EventForm />,
    route: Route,
  },
  {
    path: routes.dashboardGallery,
    element: <DashboardGallery />,
    route: Route,
  },
  {
    path: routes.addGallery,
    element: <GalleryForm />,
    route: Route,
  },
  {
    path: routes.editGallery,
    element: <GalleryForm />,
    route: Route,
  },
];

const withoutHeaderRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
];

export { dashboardRoutes, publicRoutes, withoutHeaderRoutes };
